import { render, staticRenderFns } from "./index.vue?vue&type=template&id=22570b2c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=22570b2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22570b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22570b2c')) {
      api.createRecord('22570b2c', component.options)
    } else {
      api.reload('22570b2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=22570b2c&scoped=true", function () {
      api.rerender('22570b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Store/SalesKPIRecord/index.vue"
export default component.exports